import styled from 'styled-components';

export const SearchBar = styled.div`
  max-width: 532px;
  margin-bottom: 32px;
`;

export default SearchBar;
